
import VpHeader from '@/components/AppHeader.vue'
import VpDetail from '@/components/CloudBandDetail.vue'
import VpTrend from '@/components/CloudBandTrends.vue'
import VpCurrentEvent from '@/components/CurrentEvent.vue'
import VpDisasterFilter from '@/components/DisasterFilter.vue'
import VpFooter from '@/components/Footer.vue'
import VpInfoPanel from '@/components/InfoPanel.vue'
import VpExplain from '@/components/MainExplanation.vue'
import VpSeasonDetail from '@/components/SeasonDetail.vue'
import VpTabBar from '@/components/TabBar.vue'
import VpTimeSelector from '@/components/TimeSelector.vue'
import { Component, Vue } from 'vue-property-decorator'
import VueSimpleSpinner from 'vue-simple-spinner'
import { MutationTypes } from './store/mutations'
import { ActionTypes } from './store/actions'

@Component({
	components: {
		VpHeader,
		VueSimpleSpinner,
		VpDetail,
		VpTrend,
		VpDisasterFilter,
		VpTimeSelector,
		VpSeasonDetail,
		VpCurrentEvent,
		VpExplain,
		VpInfoPanel,
		VpTabBar,
		VpFooter
	}
})
export default class App extends Vue {
	get showDisasterFilter() {
		return this.$store.state.selectedView !== 'trend'
	}

	get showHelp() {
		return this.$store.state.showOverview
	}

	get selectedView() {
		return this.$tStore.state.selectedView
	}
	get loading() {
		return this.$tStore.getters.loading
	}
	get cloudDataLoaded() {
		return this.$tStore.state.cloudData !== null
	}

	mounted() {
		const cookies = document.cookie.split(';')
		for (let cookie of cookies) {
			cookie = cookie.trim()
			const [key, value] = cookie.split('=')
			if (key === 'showOverviewOnStart') {
				this.$store.commit(
					MutationTypes.SET_SHOW_OVERVIEW_ON_START,
					value === 'true'
				)
				this.$store.commit(MutationTypes.SET_SHOW_OVERVIEW, value === 'true')
			}
		}
		this.$tStore.dispatch(ActionTypes.GET_CB_DATA, undefined)
		this.$tStore.dispatch(ActionTypes.GET_TS_DATA, undefined)
		this.$tStore.dispatch(ActionTypes.GET_GEOREF_DATA, undefined)
		this.$tStore.dispatch(ActionTypes.GET_DISASTER_DATA, undefined)
		for (let lang of navigator.languages) {
			if (lang.startsWith('en')) {
				this.$tStore.commit(MutationTypes.SET_LANGUAGE, 'en')
				break
			} else if (lang.startsWith('pt')) {
				this.$tStore.commit(MutationTypes.SET_LANGUAGE, 'pt')
				break
			}
		}
	}
}
